import { BrowserRouter, Routes, Route } from "react-router-dom";

import ScrollToTop from "@/components/common/ScrollToTop";

import Landing from "@/pages/Landing";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsAndConditions from "@/pages/legal/TermsAndConditions";
import Disclaimer from "@/pages/legal/Disclaimer";
import CookiePolicy from "@/pages/legal/CookiePolicy";
import GrievanceRedressal from "@/pages/legal/GrievanceRedressal";
import Calculators from "@/pages/Calculators";
import ClientPortal from "@/pages/ClientPortal";
import NotFound from "@/pages/NotFound";

import HomeLoan from "@/pages/loans/HomeLoan";
import BusinessLoan from "@/pages/loans/BusinessLoan";
import LoanAgainstProperty from "@/pages/loans/LoanAgainstProperty";
import CommercialPurchaseLoan from "@/pages/loans/CommercialPurchaseLoan";
import MortgageLoan from "@/pages/loans/MortgageLoan";
import ConstructionLoan from "@/pages/loans/ConstructionLoan";
import OverdraftDroplineOD from "@/pages/loans/OverdraftDroplineOD";
import CCLimit from "@/pages/loans/CCLimit";
import CarLoan from "@/pages/loans/CarLoan";
import LRDProgram from "@/pages/loans/LRDProgram";
import PersonalLoan from "@/pages/loans/PersonalLoan";
import TakeoverTopUp from "@/pages/loans/TakeoverTopUp";
import WealthBasedLoan from "@/pages/loans/WealthBasedLoan";

export default function PublicApp() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Landing />} />

        <Route path="/calculators" element={<Calculators />} />

        <Route path="/home-loan" element={<HomeLoan />} />

        <Route path="/business-loan" element={<BusinessLoan />} />

        <Route
          path="/loan-against-property"
          element={<LoanAgainstProperty />}
        />

        <Route
          path="/commercial-purchase-loan"
          element={<CommercialPurchaseLoan />}
        />

        <Route path="/mortgage-loan" element={<MortgageLoan />} />

        <Route path="/construction-loan" element={<ConstructionLoan />} />

        <Route
          path="/overdraft-dropline-od"
          element={<OverdraftDroplineOD />}
        />

        <Route path="/cc-limit" element={<CCLimit />} />

        <Route path="/car-loan" element={<CarLoan />} />

        <Route path="/lrd-program" element={<LRDProgram />} />

        <Route path="/personal-loan" element={<PersonalLoan />} />

        <Route path="/takeover-top-up" element={<TakeoverTopUp />} />

        <Route path="/wealth-based-loan" element={<WealthBasedLoan />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

        <Route path="/disclaimer" element={<Disclaimer />} />

        <Route path="/cookie-policy" element={<CookiePolicy />} />

        <Route path="/grievance-redressal" element={<GrievanceRedressal />} />

        <Route path="/portal/:token" element={<ClientPortal />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
